import React from 'react';

export const VacationsContext = React.createContext();